import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { CreateSelfInitiableMeasuredQuestionnaires } from "@/features/FillOutWizard/CreateSelfInitiableMeasuredQuestionnaires";
import { CreateSelfInitiableMeasuredQuestionnairesFormQuery } from "@/features/FillOutWizard/CreateSelfInitiableMeasuredQuestionnaires/graphql";
import { zodRespondentTypeEnum } from "@/models/respondent";

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_self_initiable_measured_questionnaires",
)({
  validateSearch: zodValidator(
    z.object({
      respondentType: zodRespondentTypeEnum,
      measuredQuestionnaireIds: z.array(z.string()),
    }),
  ),
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationKey, dossierId, measurementId } = Route.useParams();
  const { respondentType, measuredQuestionnaireIds } = Route.useSearch();
  const {
    data: {
      organization: { measurement },
      dossier: { respondent },
    },
  } = useSuspenseQuery(CreateSelfInitiableMeasuredQuestionnairesFormQuery, {
    variables: {
      organizationKey,
      dossierId,
      measurementId,
      measuredQuestionnaireIds,
      respondentType,
    },
  });

  return (
    <CreateSelfInitiableMeasuredQuestionnaires
      measurement={measurement}
      respondent={respondent}
      respondentType={respondentType}
      measuredQuestionnaireIds={measuredQuestionnaireIds}
    />
  );
}
